
const urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
export const getCustomId = ( size = 21 ) => {
  // Guard against negative sizes which would cause an infinite loop.
  if( size < 0 ){
    return '';
  }
  let id = '';
  // A compact alternative for `for (var i = 0; i < step; i++)`.
  let i = size | 0;
  while ( i-- ){
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[( Math.random() * 64 ) | 0];
  }
  return id;
};